import { Action } from 'redux';

export interface IAuthState {
  login: boolean;
  loading: boolean;
  errorMessage: string;
}
export enum AuthActionEnum {
  AuthenticateUser = '@@auth/Authenticate_User',
  AuthenticateUserSuccess = '@@/Authenticate_User_Success',
  AuthenticateUserFailure = '@@/Authenticate_User_Failure',
}

export interface IAuthenticateUserAction
  extends Action<typeof AuthActionEnum.AuthenticateUser> {
  state?: IAuthState;
}

export interface IAuthenticateUserSuccessAction
  extends Action<typeof AuthActionEnum.AuthenticateUserSuccess> {
  state?: IAuthState;
}

export interface IAuthenticateUserFailureAction
  extends Action<typeof AuthActionEnum.AuthenticateUserFailure> {
  state?: IAuthState;
}

export type AuthActions =
  | IAuthenticateUserAction
  | IAuthenticateUserSuccessAction
  | IAuthenticateUserFailureAction;
